import React, { Component } from "react";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
/**
 * 
 */
class Table extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ascendente: true,
            tarjetasOrdenadas: props.data.tarjetasDatos ? JSON.parse(JSON.stringify(props.data.tarjetasDatos)) : []
        }

        this.ordenarListaTarjeta = this.ordenarListaTarjeta.bind(this);
    }
    /**
     * Ordena la lista de tarjetas
     * @param {any} campo Parametro string, representa el nombre del campo a ordenar
     */
    ordenarListaTarjeta(campo) {
        let tarjetas = JSON.parse(JSON.stringify(this.props.data.tarjetasDatos));
        const ascendente = !this.state.ascendente;

        tarjetas = tarjetas.sort((tar1, tar2) => {
            if (tar1[campo] > tar2[campo]) {
                return ((ascendente) ? 1 : -1);
            }

            if (tar1[campo] < tar2[campo]) {
                return ((ascendente) ? -1 : 1);
            }

            return 0;
        });

        this.setState({
            ascendente: ascendente,
            tarjetasOrdenadas: tarjetas
        });
    }
    /**
     * 
     * @param {any} nextProps
     */
    componentWillReceiveProps(nextProps) {
        this.state.ascendente = true;
        this.state.tarjetasOrdenadas = JSON.parse(JSON.stringify(nextProps.data.tarjetasDatos));
    }
    /**
     * 
     */
    render() {
        return <table className="table clickeable-row-table">
            <TableHeader ordenarListaTarjeta={this.ordenarListaTarjeta} />
            <TableBody
                data={this.props.data}
                tarjetas={this.state.tarjetasOrdenadas}
                funciones={this.props.funciones} />
        </table>
    }
}

export default Table;